module.exports = __webpack_public_path__ + "static/media/national_day_cat_icon_big.aaca8582.png";